import { useSearchParams } from 'react-router-dom';
import { useVerifyEmail } from 'api/InvoiceDetails/sdk.ts';
import { useNavigate, useParams } from 'react-router';
import { Fragment, useEffect, useState } from 'react';
import { P } from 'components/ui/typography.tsx';
import { useTranslation } from 'react-i18next';
import Navigation from 'components/Navigation';
import Footer from 'components/Footer';
import Loader from 'components/Loader';

export const VerifyEmail = () => {
  const [searchParams] = useSearchParams();
  const params = useParams();
  const verificationUrl = searchParams.get('verificationUrl');
  const verificationUrlObject = verificationUrl ? new URL(verificationUrl) : null;
  const urlComponents = verificationUrlObject
    ? verificationUrlObject.pathname.slice(1) + verificationUrlObject.search + verificationUrlObject.hash
    : '';
  const { data, error, isLoading } = useVerifyEmail(urlComponents);
  const [verifyError, setVerifyError] = useState(false);
  const navigate = useNavigate();
  const { t } = useTranslation();

  const getEmailFromVerificationUrl = (verificationUrl: string | null) => {
    if (!verificationUrl) return '';
    const url = new URL(verificationUrl);
    const emailParam = url.pathname.split('/').filter(Boolean).pop();

    return emailParam ? decodeURIComponent(decodeURIComponent(emailParam)) : '';
  };

  const email = getEmailFromVerificationUrl(verificationUrl);

  useEffect(() => {
    if (data) {
      navigate(`/flights/offer/${params?.flightTicketRequestUUID}/invoice-details`, {
        replace: true,
        state: { email },
      });
    } else if (error) {
      setVerifyError(true);
    }
  }, [data, email, error, navigate, params?.flightTicketRequestUUID]);

  return (
    <Fragment>
      <Navigation />
      <div className='flex min-h-screen items-center justify-center p-4'>
        {isLoading && <Loader className='size-20 text-content-primary' />}
        {verifyError && <P>{t('invoiceDetails.invalidLink')}</P>}
      </div>
      <Footer />
    </Fragment>
  );
};
